import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Badge } from '../../ui';
import { IconClock } from '@maia/icons';

type Props = {
  timestamp?: {
    showIcon?: boolean;
    date: string;
  };
} & HTMLAttributes<HTMLDivElement>;

export function CardFooter(props: Props) {
  const { timestamp, children, className, ...rest } = props;

  return (
    <div
      className={twMerge(
        'flex justify-between items-center space-x-12',
        className,
      )}
      {...rest}
    >
      {children && children}
      {timestamp && (
        <Badge
          icon={timestamp.showIcon ? IconClock : undefined}
          label={timestamp.date}
          className="justify-self-end ml-auto"
          variant="disabled"
          spacing="small"
        />
      )}
    </div>
  );
}
